import { NIGHTBOT_AUTH } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { authenticationTypes } from 'root/src/shared/constants/auth'

export default {
	[NIGHTBOT_AUTH]: {
		authentication: authenticationTypes.unauthenticated,
	},
}
